// Auto-generated
export const fadeIn = {
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
};

export const fadeOut = {
  '0%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0,
  },
};

export const slideInRight = {
  '0%': {
    transform: 'translateX(100%)',
  },
  '100%': {
    transform: 'translateX(0)',
  },
};

export const slideInLeft = {
  '0%': {
    transform: 'translateX(-100%)',
  },
  '100%': {
    transform: 'translateX(0)',
  },
};

export const slideInTop = {
  '0%': {
    transform: 'translateY(-100%)',
  },
  '100%': {
    transform: 'translateY(0)',
  },
};

export const slideInBottom = {
  '0%': {
    transform: 'translateY(100%)',
  },
  '100%': {
    transform: 'translateY(0)',
  },
};

export const slideOutRight = {
  '0%': {
    transform: 'translateX(0)',
  },
  '100%': {
    transform: 'translateX(100%)',
  },
};

export const slideOutLeft = {
  '0%': {
    transform: 'translateX(0)',
  },
  '100%': {
    transform: 'translateX(-100%)',
  },
};

export const slideOutTop = {
  '0%': {
    transform: 'translateY(0)',
  },
  '100%': {
    transform: 'translateY(-100%)',
  },
};

export const slideOutBottom = {
  '0%': {
    transform: 'translateY(0)',
  },
  '100%': {
    transform: 'translateY(100%)',
  },
};
